<script>
// Sidebar instructor — Estilo APPMISIONATE
import MainMenuComponent from '../features/MainMenuComponent';
import BrandLogo from '../BrandLogo.vue';

export default {
  name: 'MainMenuInstructorView',
  components: { BrandLogo },
  mixins: [MainMenuComponent],
};
</script>
<template>
  <!-- Left Sidebar — estilo APPMISIONATE -->
  <nav class="sidebar-ap" id="sidebarAp">
    <!-- Logo -->
    <div class="sidebar-logo">
      <BrandLogo text-class="sidebar-logo-text" />
    </div>

    <!-- Navegación principal -->
    <div class="sidebar-nav">
      <router-link
        v-if="onCanShowModule('Dashboard-Module')"
        :to="'/profesor/resumen'"
        class="sidebar-link"
        active-class="active"
        title="Resumen"
      >
        <i class="fas fa-th-large menu--icon"></i>
        <span class="menu--label">Resumen</span>
      </router-link>

      <router-link
        v-if="onCanShowModule('LiveClassContent-Module')"
        :to="'/profesor/en-vivo'"
        class="sidebar-link"
        active-class="active"
        title="Clases en vivo"
      >
        <i class="fas fa-broadcast-tower menu--icon"></i>
        <span class="menu--label">
          En Vivo
          <span class="menu--live-badge">LIVE</span>
        </span>
      </router-link>

      <router-link
        v-if="onCanShowModule('CourseContent-Module')"
        :to="'/profesor/cursos'"
        class="sidebar-link"
        active-class="active"
        title="Cursos"
      >
        <i class="fas fa-book-open menu--icon"></i>
        <span class="menu--label">Cursos</span>
      </router-link>

      <router-link
        v-if="onCanShowModule('CourseContent-Module')"
        :to="'/profesor/actividades'"
        class="sidebar-link"
        active-class="active"
        title="Actividades"
      >
        <i class="fas fa-tasks menu--icon"></i>
        <span class="menu--label">Actividades</span>
      </router-link>

      <div class="sidebar-divider"></div>

      <router-link
        v-if="onCanShowModule('NotificationsContent-Module')"
        :to="'/profesor/notificaciones'"
        class="sidebar-link"
        active-class="active"
        title="Notificaciones"
      >
        <i class="fas fa-bell menu--icon"></i>
        <span class="menu--label">Notificaciones</span>
      </router-link>

      <router-link
        :to="'/profesor/mi-cuenta'"
        class="sidebar-link"
        active-class="active"
        title="Mi Cuenta"
      >
        <i class="fas fa-user-circle menu--icon"></i>
        <span class="menu--label">Mi Cuenta</span>
      </router-link>

      <!-- Configuraciones -->
      <div class="sidebar-section-label" style="margin-top:8px;">Configuraciones</div>

      <router-link
        :to="'/profesor/configuraciones/categorias-de-cursos'"
        class="sidebar-link"
        active-class="active"
        title="Categorías de Cursos"
      >
        <i class="fas fa-cog menu--icon"></i>
        <span class="menu--label">Categorías</span>
      </router-link>
    </div>

    <!-- Footer del sidebar -->
    <div class="sidebar-footer">
      <div class="sidebar-footer-links">
        <a href="/">Inicio</a>
        <a href="/acerca">Acerca</a>
        <a href="/noticias">Noticias</a>
        <a href="/contacto">Contacto</a>
      </div>
      <div class="sidebar-copyright">
        © 2026 <strong>Appmisiónate</strong>.
        Todos los Derechos Reservados.
      </div>
    </div>
  </nav>
</template>
